module.exports = __webpack_public_path__ + "static/media/add_photo_alternate-24px.3ce73900.svg";